import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { hasInteracted, setConsent } from "@/lib/cookie-consent";
import { initializeAnalytics } from "@/lib/analytics";
import { CookiePreferencesSheet } from "./CookiePreferencesSheet";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [prefsOpen, setPrefsOpen] = useState(false);

  useEffect(() => {
    // Don't show if user already interacted or GPC is enabled
    if (!hasInteracted() && navigator.globalPrivacyControl !== true) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setConsent({ analytics: true });
    initializeAnalytics();
    setVisible(false);
  };

  if (!visible && !prefsOpen) return null;

  return (
    <>
      {visible && !prefsOpen && (
        <div
          role="region"
          aria-label="Cookie consent"
          className="fixed bottom-0 inset-x-0 z-50 animate-in slide-in-from-bottom duration-300"
        >
          <div className="bg-background border-t shadow-lg">
            <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <p className="text-sm text-muted-foreground flex-1">
                We use cookies to analyze site traffic and improve your experience.
                By continuing to use this site, you accept our use of cookies.
              </p>
              <div className="flex items-center gap-3 shrink-0">
                <button
                  onClick={() => setPrefsOpen(true)}
                  className="text-sm underline text-muted-foreground hover:text-foreground transition-colors"
                >
                  Manage Preferences
                </button>
                <Button size="sm" onClick={handleAccept}>
                  Accept
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CookiePreferencesSheet
        open={prefsOpen}
        onOpenChange={(open) => {
          setPrefsOpen(open);
          if (!open && hasInteracted()) {
            setVisible(false);
          }
        }}
      />
    </>
  );
};
